import { render, staticRenderFns } from "./rate-field-error.vue?vue&type=template&id=2cba6688"
import script from "./rate-field-error.vue?vue&type=script&lang=js"
export * from "./rate-field-error.vue?vue&type=script&lang=js"
import style0 from "./rate-field-error.vue?vue&type=style&index=0&id=2cba6688&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports